import wywLog from '@/utils/ubcLog';

/**
 * 添加监听
 * @param {*} options
 * @param {*} options.callback 曝光回调
 * @param {*} options.isNotRepeat 是否不重复曝光，默认重复
 * @param {*} options.threshold 曝光触发阈值,支持传数组
 * @param {*} ext 打点数据
 * @param {*} ext.area 打点area，不传不打
 * @param {*} ext.serverId 打点id
 * @param {Boolean} ext.isLog 是否曝光打点
 * @param {String} ext.rootMargin 根边界盒与目标元素边界的偏移量
 * @returns
 */
const addObserver = (options, ext) => {
    const {callback, isNotRepeat = false, threshold = 0.9, isLog = true, rootMargin = '0px'} = options || {};
    // 注意浏览器调试窗口遮挡，遮挡可能导致不能触发
    const observer = new IntersectionObserver(
        changes => {
            changes.forEach(change => {
                if (!isLog) {
                    typeof callback === 'function' && callback(change);
                }
                else if (change.intersectionRatio > threshold) {
                    ext && ext.area && wywLog.send({
                        action: 'show',
                        ...ext
                    });
                    typeof callback === 'function' && callback();
                    // 停止监听
                    isNotRepeat && observer.unobserve(change.target);
                    return;
                }
            });
        },
        {
            rootMargin,
            // 如果不设置threshold  那么默认element intersectionRatio = 0就是没在页面展示的时候 就已经触发了 回掉函数
            threshold: threshold.length ? threshold : [threshold]
        }
    );
    return observer;
};


/**
 * 曝光指令
 * 重载1
 * v-visually="handleShow"   --多次曝光触发行为
 * @param {Function} value 直接指定回调，重复曝光触发
 * 重载2
 * v-visually="{callback: handleShow, isNotRepeat: true}"   --单次曝光触发行为
 * v-visually="{serverId: 1xxxx, area: 'somearea', isNotRepeat: true}"   --单次曝光打点
 * @param {Object} value 传入对象
 * @param {Function} value.callback 曝光回调
 * @param {boolean} value.isNotRepeat 是否不重复曝光
 * @param {number} value.threshold 曝光触发阈值
 * @param {string} value.area 打点area
 * @param {string|number} value.serverId 打点id
 * @param {Object} value.ext 其余打点信息
 */
export default {
    bind(el, {value}) {
        if (value) {
            // 直接指定callback
            if (typeof value === 'function') {
                el.$observer = addObserver({callback: value});
            }
            else if (Object.keys(value).length) {
                const {callback, isNotRepeat, threshold, serverId, area, ext, isLog, rootMargin} = value;
                el.$observer = addObserver({
                    callback,
                    isNotRepeat,
                    threshold,
                    isLog,
                    rootMargin
                }, {
                    serverId,
                    area,
                    ...ext
                });
            }
            typeof el.$observer.observe === 'function' && el.$observer.observe(el);
        }
    },
    // 当传进来的值更新的时候触发
    componentUpdated(el, {value}) {
        // TODO: 传值变化处理，防抖
    },
    // 指令与元素解绑的时候，移除事件绑定
    unbind(el) {
        if (el.$observer) {
            typeof el.$observer.disconnect === 'function' && el.$observer.disconnect();
        }
    }
};